import { DiscussionMessages_discussionMessages_messages } from '../graphql/discussion/types/DiscussionMessages';

export const getUnseenMessageIds = (
  messages:
    | (DiscussionMessages_discussionMessages_messages | null)[]
    | null
    | undefined,
) =>
  messages?.reduce<number[]>((ids, message): number[] => {
    if (
      message?.id !== null &&
      message?.id !== undefined &&
      !message?.isSeenByMe
    ) {
      ids.push(message.id);
    }
    return ids;
  }, []);
